import script from "./AdCreatorTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdCreatorTable.vue?vue&type=script&setup=true&lang=js"

import "./AdCreatorTable.vue?vue&type=style&index=0&id=ddb9befe&lang=scss"

const __exports__ = script;

export default __exports__